module.exports = __webpack_public_path__ + "img/signup.87d1f6bc.png";